
import {Component, Mixins, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";

interface AvukatEntity {
  id: number;
  first_name: string;
  last_name: string;
}

@Component({})
export default class AvukatSecim extends Mixins(ObjectInputMixin) {

  // UI State
  isMenuOpen: boolean = false;
  isLoading: boolean = false;
  search: string = '';
  selectAll: boolean = false;

  // Data State
  items: Array<string> = [];
  allData: Array<AvukatEntity> = [];
  checkedItems: { [key: string]: boolean } = {};

  // Computed
  get filteredItems(): Array<string> {
    return this.items.filter((item: string) =>
        item.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  get hasSelection(): boolean {
    return Object.values(this.checkedItems).some(value => value);
  }

  get selectedAvukatIds(): Array<number> {
    const ids: Array<number> = [];
    for (const [itemName, isChecked] of Object.entries(this.checkedItems)) {
      if (isChecked) {
        const avukat = this.findAvukatByName(itemName);
        if (avukat) {
          ids.push(avukat.id);
        }
      }
    }
    return ids;
  }

  // Lifecycle
  mounted(): void {
    this.fetchAvukatList();
  }

  // Watchers
  @Watch('selectAll')
  onSelectAllChanged(value: boolean): void {
    this.setAllCheckedItems(value);
  }

  // Public Methods
  async handleApply(): Promise<void> {
    if (!this.hasSelection) return;

    this.isLoading = true;
    try {
      const muvekkilList = await this.fetchMuvekkilListByAvukat();
      this.emitSelections(muvekkilList);
      this.isMenuOpen = false;
    } catch (error) {
      console.error('Müvekkil listesi alınamadı:', error);
    } finally {
      this.isLoading = false;
    }
  }

  toggleItem(item: string): void {
    this.$set(this.checkedItems, item, !this.checkedItems[item]);
  }

  // Private Methods
  private async fetchAvukatList(): Promise<void> {
    try {
      const response: Array<AvukatEntity> = await this.$http.get('/api/v1/tahsilat-avukat-list/');
      this.allData = response;
      this.initializeItems(response);
    } catch (error) {
      console.error('Avukat listesi alınamadı:', error);
    }
  }

  private async fetchMuvekkilListByAvukat(): Promise<any> {
    const response: any = await this.$http.post('/api/v1/avukat-muvekkil-list/', {
      avukat_id: this.selectedAvukatIds
    });
    return response;
  }

  private initializeItems(avukatList: Array<AvukatEntity>): void {
    this.items = avukatList.map((avukat: AvukatEntity) => {
      const fullName = this.getFullName(avukat);
      this.$set(this.checkedItems, fullName, false);
      return fullName;
    });
  }

  private setAllCheckedItems(value: boolean): void {
    for (const key in this.checkedItems) {
      if (Object.prototype.hasOwnProperty.call(this.checkedItems, key)) {
        this.$set(this.checkedItems, key, value);
      }
    }
  }

  private findAvukatByName(fullName: string) {
    return this.allData.find((avukat: AvukatEntity) =>
        this.getFullName(avukat) === fullName
    );
  }

  private getFullName(avukat){
    return `${avukat.ad} ${avukat.soyad}`;
  }

  private emitSelections(muvekkilList: any): void {
    this.$emit('selectedAvukatIds', this.selectedAvukatIds);
    this.$emit('muvekkilList', muvekkilList);
  }
}
